/* eslint-disable import/no-duplicates */
import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { ThemeProvider } from "styled-components";

import { useHistory } from "react-router-dom";
import { ReactComponent as PersonAtComputer } from "../assets/images/home-image.svg";
import { ReactComponent as NotificationIcon } from "../assets/icons/Bell.svg";
import NotificationService from "../service/Docente/NotificationService";
import GenericUtils from "../utils/GenericUtils";
import Dialog from "../components/Dialog";
import DialogStyles from "../styles/components/DialogStyles";
import ButtonStyles from "../styles/components/ButtonStyles";
import { TipoNotificacaoEnum } from "../model/Enums/TipoNotificacaoEnum";
import { StyledFormCheckNotification, StyledLabel } from "../styles/MainStyles";
import { ReactComponent as InfoIcon } from "../assets/icons/InfoIcon.svg";
import ClockIcon from "../assets/icons/ClockHomeIcon.svg";
import LampIcon from "../assets/icons/LampHomeIcon.svg";
import TargetIcon from "../assets/icons/TargetHomeIcon.svg";
import FilesIcon from "../assets/icons/FilesHomeIcon.svg";
import HomeStyles from "../styles/pages/HomeStyles";
import { StyledHrNav } from "../styles/components/NavBarStyles";
import HomeCard from "./HomeCard";
import { UserRole } from "../model/Enums/UserRoleEnum";

type NotificationWithSubjectType = [string, string];

const {
    StyledTitle,
    StyledWelcome,
    StyledComment,
    StyledBenefits,
    StyledText,
    StyledDiv,
    StyledGridDiv,
} = HomeStyles;

const { StyledModalTitle, StyledModalText, StyledContainerButton } =
    DialogStyles;

const { BtnPrimary } = ButtonStyles;

function Home() {
    const { instance } = useMsal();
    const [notifications, setNotifications] = useState<
        Array<NotificationWithSubjectType>
    >([]);
    const [blockingPeriods, setBlockingPeriods] = useState<any[]>([]);
    const [checked, setChecked] = useState(false);
    const [forceUpdate, setForceUpdate] = useState(false);
    const [validCheck, setValidCheck] = useState(true);
    const account = GenericUtils.getUserAccount();
    const user = GenericUtils.getUser();
    const theme = {};
    const fullName = account?.name;
    const firstName = (fullName || "").split(" ");
    const userfirstName = firstName[0] || "docente";
    const text01 = "Faça rapidamente check-in das suas atividades";
    const text02 = "Organize e visualize os detalhes do seu calendário";
    const text03 = "Realize a gestão de dados e informações";
    const text04 = "Acesse o que você precisa em um único lugar";

    async function getNotificationsChange(matriculaAdp: string) {
        const notificationPromisses = [
            NotificationService.getNotifications(
                matriculaAdp,
                TipoNotificacaoEnum.AtualizacaoCargaHorariaDocente,
                instance
            ),
            NotificationService.getNotifications(
                matriculaAdp,
                TipoNotificacaoEnum.ActivityManagement,
                instance
            ),
        ];

        const [teacherWorkloadNotification, activityManagementNotification] =
            await Promise.all(notificationPromisses);

        if (
            GenericUtils.isSuccessStatus(teacherWorkloadNotification?.status) ||
            GenericUtils.isSuccessStatus(activityManagementNotification?.status)
        ) {
            const allNotificationsAndSubjects = [
                ...(teacherWorkloadNotification?.data?.map((item: any) => [
                    item.assunto,
                    item.mensagem,
                ]) || []),
                ...(activityManagementNotification?.data?.map((item: any) => [
                    item.assunto,
                    item.mensagem,
                ]) || []),
            ];

            setNotifications(allNotificationsAndSubjects);
        }
    }

    async function getNotificationsBlock(
        matriculaAdp: string,
        limpar: boolean
    ) {
        const response = await NotificationService.getNotifications(
            matriculaAdp,
            TipoNotificacaoEnum.PeriodoBloqueioPlanoAtividade,
            instance,
            limpar
        );

        if (GenericUtils.isSuccessStatus(response?.status)) {
            setBlockingPeriods(
                response?.data?.map((item: any) => item.mensagem)
            );
        }
    }

    useEffect(() => {
        if (!forceUpdate) {
            setForceUpdate(true);
        }
    }, [forceUpdate]);

    useEffect(() => {
        if (user && validCheck) {
            getNotificationsChange(user?.docente?.matriculaAdp);
            getNotificationsBlock(user?.docente?.matriculaAdp, false);
            setValidCheck(false);
        }
    }, [user]);

    const handleNotificationBlock = () => {
        setValidCheck(false);
        if (checked) {
            getNotificationsBlock(user?.docente?.matriculaAdp, true).then(() =>
                setBlockingPeriods([])
            );
        } else {
            setBlockingPeriods([]);
        }
    };

    const handleNotification = () => {
        setNotifications([]);
        setBlockingPeriods([]);
        setValidCheck(false);
    };

    const dialogNotificationBlock = (
        <Dialog
            openModal={!!blockingPeriods.length}
            onHide={handleNotification}
            size="width-300"
            modalIcon={<NotificationIcon />}
        >
            <StyledModalTitle style={{ fontSize: "22px" }}>
                Período de edição TACH
            </StyledModalTitle>
            <StyledModalText
                style={{ marginTop: "24px", marginBottom: "24px" }}
            >
                {blockingPeriods[0]}
            </StyledModalText>

            <StyledModalText
                style={{ marginTop: "24px", marginBottom: "24px" }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <StyledFormCheckNotification
                        type="checkbox"
                        onChange={(event: any) =>
                            setChecked(event.target.checked)
                        }
                    />
                    <StyledLabel
                        marginB={0}
                        style={{
                            fontSize: 16,
                            fontWeight: 400,
                            lineHeight: "48px",
                            color: "#8A0538",
                            marginLeft: 8,
                        }}
                    >
                        Não exibir novamente
                    </StyledLabel>
                </div>
            </StyledModalText>
            <StyledContainerButton>
                <BtnPrimary onClick={handleNotificationBlock}>Ok</BtnPrimary>
            </StyledContainerButton>
        </Dialog>
    );

    const dialogNotificationChange = (
        <Dialog
            openModal={!!notifications.length}
            onHide={handleNotification}
            size="width-300"
        >
            <StyledModalTitle style={{ fontSize: "22px" }}>
                {notifications && notifications.length > 0
                    ? notifications[0][0]
                    : "Gestão de Atividades"}
            </StyledModalTitle>
            <StyledModalText
                style={{ marginTop: "24px", marginBottom: "24px" }}
            >
                {notifications &&
                    notifications.length > 0 &&
                    notifications[0][1]}
            </StyledModalText>
            <StyledModalText
                style={{ marginTop: "24px", marginBottom: "24px" }}
            >
                Atenciosamente.
            </StyledModalText>

            <StyledContainerButton>
                <BtnPrimary onClick={handleNotification}>Ok</BtnPrimary>
            </StyledContainerButton>
        </Dialog>
    );

    return (
        <ThemeProvider theme={theme}>
            <div style={{ marginLeft: "60px" }}>
                <div style={{ display: "flex" }}>
                    <div
                        style={{
                            maxWidth: "634px",
                            alignItems: "left",
                            padding: "48px 0 0 0",
                        }}
                    >
                        <StyledWelcome>Olá, {userfirstName}!</StyledWelcome>
                        <StyledTitle>
                            Você está na nova Agenda Docente.
                        </StyledTitle>
                        <StyledComment>
                            Uma plataforma exclusiva para facilitar o seu dia a
                            dia.
                        </StyledComment>
                    </div>
                    <div className="not-click">
                        <PersonAtComputer />
                    </div>
                </div>
            </div>
            <StyledHrNav style={{ width: "95%", marginLeft: "30px" }} />
            <div style={{ marginLeft: "60px" }}>
                <StyledBenefits>
                    Vantagens para otimizar suas tarefas diárias!
                </StyledBenefits>
                <StyledGridDiv>
                    <HomeCard
                        icon={ClockIcon}
                        imgDescription="Ícone representando um relógio"
                        title="+ Rápido"
                        text={text01}
                    />
                    <HomeCard
                        icon={LampIcon}
                        imgDescription="Ícone representando uma lâmpada"
                        title="+ Intuitivo"
                        text={text02}
                    />
                    <HomeCard
                        icon={TargetIcon}
                        imgDescription="Ícone representando um alvo"
                        title="+ Fácil"
                        text={text03}
                    />
                    <HomeCard
                        icon={FilesIcon}
                        imgDescription="Ícone representando arquivos"
                        title="+ Organizado"
                        text={text04}
                    />
                </StyledGridDiv>
                <StyledDiv>
                    <InfoIcon style={{ margin: "3px" }} />
                    <StyledText>
                        Para começar, navegue no menu ao lado. Boas-vindas!
                    </StyledText>
                </StyledDiv>
            </div>
            {!!notifications.length && dialogNotificationChange}
            {!!blockingPeriods.length && dialogNotificationBlock}
        </ThemeProvider>
    );
}

export default Home;
